import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';
import { heroData } from '../mockData';

const Hero = () => {
  const handleJoinCommunity = () => {
    const ctaSection = document.getElementById('cta-join');
    ctaSection?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleSignUpSession = () => {
    const ctaSection = document.getElementById('cta-session');
    ctaSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          {/* Badge */}
          <div className="hero-badge">
            <Sparkles size={16} />
            <span>Powered by DobbleHelix</span>
          </div>

          {/* Main Heading */}
          <h1 className="hero-title">
            <span className="hero-title-rails">{heroData.title}</span>
            <span className="hero-title-subtitle">{heroData.subtitle}</span>
          </h1>

          {/* Description */}
          <p className="hero-description">{heroData.description}</p>

          {/* CTA Buttons */}
          <div className="hero-cta">
            <Button 
              className="hero-button-primary"
              onClick={handleJoinCommunity}
            >
              {heroData.primaryCTA}
              <ArrowRight size={20} />
            </Button>
            <Button 
              variant="outline" 
              className="hero-button-secondary"
              onClick={handleSignUpSession}
            >
              {heroData.secondaryCTA}
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="hero-trust">
            <div className="trust-item">
              <span className="trust-number">1000+</span>
              <span className="trust-label">Active Learners</span>
            </div>
            <div className="trust-divider"></div>
            <div className="trust-item">
              <span className="trust-number">25+</span>
              <span className="trust-label">Projects Done</span>
            </div>
            <div className="trust-divider"></div>
            <div className="trust-item">
              <span className="trust-number">50+</span>
              <span className="trust-label">Training Sessions</span>
            </div>
            <div className="trust-divider"></div>
            <div className="trust-item">
              <span className="trust-number">20+</span>
              <span className="trust-label">Industries</span>
            </div>
          </div>
        </div>

        {/* Hero Image */}
        <div className="hero-image-container">
          <div className="hero-image-wrapper">
            <img 
              src={heroData.heroImage} 
              alt="RAILS by DX Community" 
              className="hero-image"
            />
            <div className="hero-image-overlay"></div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="scroll-indicator">
        <div className="scroll-line"></div>
      </div>
    </section>
  );
};

export default Hero;
